import React from "react";
import { ReportSummaryItemApi } from "../api/Reports";

import TabsSelection from "../shared-components/TabsSelection";
import { AmendmentEditProfiles } from "./AmendmentEditProfiles";

import ErrorMessageContainer from "../shared-components/ErrorMessageContainer";
import { WORKFLOW_STEP_STATUS_ENUM } from "../api/Workflows";
import { useReportDetail } from "../reports/ReportDetailProvider";

enum AmendmentTabEnum {
  PROFILE = "PROFILE",
  POST = "POST",
}
type AmendmentProps = {
  isReadOnly?: boolean;
  report?: ReportSummaryItemApi;
};

const Amendment = ({ isReadOnly, report }: AmendmentProps) => {
  const { errorBlueprint } = useReportDetail();

  let initialTab = AmendmentTabEnum.PROFILE;

  if (!report) {
    return <span data-testid="empty-reports">Report Cannot be loaded.</span>;
  }

  if (report.step_name === WORKFLOW_STEP_STATUS_ENUM.PostsManualRate) {
    initialTab = AmendmentTabEnum.POST;
  }

  return (
    <>
      <AmendmentTabSelection report={report} initialTab={initialTab} />
      <div>
        {initialTab === AmendmentTabEnum.PROFILE && (
          <AmendmentEditProfiles report={report} isReadOnly={isReadOnly} />
        )}
      </div>
      {errorBlueprint && (
        <ErrorMessageContainer message="Error Loading behaviors" />
      )}
    </>
  );
};

function AmendmentTabSelection({
  report,
  initialTab,
}: {
  report: ReportSummaryItemApi;
  initialTab: AmendmentTabEnum;
}) {
  const tabs = {
    profile: {
      identifier: AmendmentTabEnum.PROFILE,
      label: "Edit Profiles",
    },
    post: {
      identifier: AmendmentTabEnum.POST,
      label: "Edit Posts",
    },
  };

  return (
    <TabsSelection
      tabs={[
        initialTab === AmendmentTabEnum.PROFILE ? tabs.profile : tabs.post,
      ]}
      initial={initialTab}
      enabled={false}
    ></TabsSelection>
  );
}

export default Amendment;
